import { Component, Input } from '@angular/core';
import { AddressForm } from '../../model/application-form.model';
import { FormGroup } from '@angular/forms';
import { FormErrorsConditionOperator, GooglePlacesFormHelper, GooglePlacesDetails } from 'common';
import { AppFormValidationData } from "../application-form/application-form.data";
import { states } from 'common'

@Component({
    selector: 'ifm-address-form',
    templateUrl: './address-form.component.html',
    styleUrls: ['./address-form.component.scss'],
    standalone: false
})
export class AddressFormComponent {
  @Input() form: FormGroup<AddressForm>;

  readonly States = states;
  readonly ConditionOperator = FormErrorsConditionOperator;
  readonly ValidationData = AppFormValidationData;

  handleStreetAddressChange(placeDetails: GooglePlacesDetails): void {
    const mappedData = GooglePlacesFormHelper.mapToFullAddress(placeDetails);
    this.form.patchValue(mappedData, { emitEvent: false });
  }

  handleCityAddressChange(placeDetails: GooglePlacesDetails): void {
    const mappedData = GooglePlacesFormHelper.mapToCityAddress(placeDetails);
    this.form.patchValue(mappedData, { emitEvent: false });
  }
}
